module.exports = __webpack_public_path__ + "img/5.f77ac2d9.png";